import moment from 'moment-timezone';

const CHECK_IN_TIME_GAP_MINUTES = 15;

export const isStillInTimeGap = (checkInTime: string): boolean => {
  return moment().diff(moment(`${checkInTime}Z`), 'm') < CHECK_IN_TIME_GAP_MINUTES;
};
